module.exports = __webpack_public_path__ + "static/media/room-hero.6ffd706a.jpg";